module.exports = __webpack_public_path__ + "media/reskin-images/icon--webinars-a25677ba.svg";